import React, { Component } from 'react';
import { CssBaseline, Grid, withStyles } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';

const moment = require('moment');

const StyledTableCell = withStyles((theme) => ({
  head: {
    padding: '8px 16px',
    fontSize: '1rem',
    borderBottomStyle: 'none',
    backgroundColor: theme.palette.primary.main,
  },
  body: {
    fontSize: '1rem',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    [theme.breakpoints.down('sm')]: {
      padding: '10px',
    },
  },
}))(TableCell);

const styles = (theme) => ({});

class EvtNotiList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  sendState = (event, val, notiItem) => {
    // console.log(notiItem);
    this.props.changeState(val);
    this.props.selectedItem(notiItem);
  };

  render() {
    // console.log('notice에서 받아온 데이터');
    // console.log(this.props.data);

    const mapToComponent = (datas) => {
      datas = this.props.data;
      // console.log(datas);

      return datas.map((notiItem, i) => {
        return (
          <TableRow key={i}>
            <StyledTableCell
              align="left"
              style={{ cursor: 'pointer' }}
              onClick={(e) => {
                this.sendState(e, 'detail', notiItem);
              }}
            >
              {notiItem.title}
            </StyledTableCell>
            <StyledTableCell align="center">{moment(Number(notiItem.createdAt)).format('YYYY-MM-DD')}</StyledTableCell>
          </TableRow>
        );
      });
    };

    return (
      <React.Fragment>
        <CssBaseline />
        <Grid style={{ minHeight: '50vh', width: '100%' }}>
          <TableContainer style={{ boxShadow: 'none', marginBottom: '1em' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    align="center"
                    width={window.matchMedia('(max-width:600px)').matches ? '65%' : '80%'}
                    style={{ borderRadius: '30px  0 0 30px' }}
                  >
                    <span style={{ fontWeight: 'bold', color: '#ffffff' }}>제목</span>
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    width={window.matchMedia('(max-width:600px)').matches ? '35%' : '20%'}
                    style={{ borderRadius: '0 30px  30px 0' }}
                  >
                    <span style={{ fontWeight: 'bold', color: '#ffffff' }}>등록일</span>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>{this.props.data && mapToComponent(this.props.data)}</TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(EvtNotiList);
